import { render, staticRenderFns } from "./UjianList.vue?vue&type=template&id=3515e6fc&scoped=true"
import script from "./UjianList.vue?vue&type=script&lang=js"
export * from "./UjianList.vue?vue&type=script&lang=js"
import style0 from "./UjianList.vue?vue&type=style&index=0&id=3515e6fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515e6fc",
  null
  
)

export default component.exports